export const copyObj = (obj: any) => JSON.parse(JSON.stringify(obj));
